// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/inline-suggest.scss
// module id = 6
// module chunks = 0